export const VIEW_TODAYS_PRICE_CHANGE_PERIOD_YEARS = 2;
